// Who sees every event in an organization (BON-885).
//
// LinkedIn's requirement: planners must not see each other's events. The
// organization's owner and its OWNER/ADMIN members see every event (All
// Events, organization-wide reporting); MEMBER and VIEWER see only the events
// they created.
//
// The backend enforces this (bonni-backend src/utils/event-access.ts); this
// only decides what the web offers. It reads the role list-organizations
// returns on the current organization, so it needs no extra request.

export type OrganizationRole = {
  role?: string | null;
  isOwner?: boolean | null;
};

const ORGANIZATION_WIDE_EVENT_ROLES = ["OWNER", "ADMIN"];

/** Whether this organization membership sees every event in the organization. */
export function canSeeAllOrganizationEvents(
  organization: OrganizationRole | null | undefined,
): boolean {
  if (!organization) return false;
  if (organization.isOwner) return true;
  return ORGANIZATION_WIDE_EVENT_ROLES.includes(
    (organization.role ?? "").toUpperCase(),
  );
}

export type AllEventsRouteDecision = "wait" | "allow" | "redirect";

/** What the /all-events route does while, and once, the organization is known. */
export function allEventsRouteDecision({
  loading,
  organization,
}: {
  loading: boolean;
  organization: OrganizationRole | null | undefined;
}): AllEventsRouteDecision {
  if (loading) return "wait";
  return canSeeAllOrganizationEvents(organization) ? "allow" : "redirect";
}

/** The route members are sent to instead of All Events. */
export const OWN_EVENTS_ROUTE = "/my-events";
